export const SELECTEDCHECKBOXVAL = 'SELECTEDCHECKBOXVAL';

export const SelectedCheckboxAction = (val) => async (dispatch) => {
    dispatch({
        type: SELECTEDCHECKBOXVAL,
        payload: val,
    });
}
